<div class="unselectable">
    <div class="row">
        <div class="col-12">
            <div class="asset-tool-bar">
                <div class="info-bar">
                    @if(totalItems) {
                        <span class="results">
                             @if(blocked) {
                                 <span class="smallSpinner loading result-spinner">
                                            <span class="spinner-wrapper">
                                                <span class="spinner"></span>
                                            </span>
                                 </span>
                             }
                            <span class="result-value" [ngClass]="{'isBlocked': blocked}">{{totalItems}} Results</span></span>
                    }

                </div>
               <div class="view-toggle">
                   @if( assetCount && assetCount.assetsSelected && assetCount.assetsSelected > 0) {
                       <span class="assetCount">
                           {{assetCount.assetsSelected}} {{'assetCount.selected' | translate}}
                       </span>
                       <button class="me-2" mat-icon-button [matTooltip]="'action.clearSelection'|translate" (click)="clearSelectedAssets()">
                           <mat-icon  aria-hidden="false" fontIcon="unpublished" ></mat-icon>
                       </button>
                   }

                   @if(assetFilter && totalItems) {
                       <mat-form-field>
                           <mat-select [(ngModel)]="assetFilter.orderBy" (selectionChange)="updateFilter()">
                               <mat-option class="option" [value]="OrderBy.created">{{'collection.orderby' | translate}} <span class="bold">{{OrderBy.created | translate}}</span></mat-option>
                               <mat-option class="option" [value]="OrderBy.modified">{{'collection.orderby' | translate}} <span class="bold">{{OrderBy.modified | translate}}</span></mat-option>
                           </mat-select>
                       </mat-form-field>
                       @if(assetFilter.order === OrderDirection.desc) {
                           <button mat-icon-button><mat-icon  aria-hidden="false" (click)="toggleSortOrder()" fontIcon="arrow_downward"></mat-icon></button>
                       }
                       @if(assetFilter.order === OrderDirection.asc) {
                           <button mat-icon-button><mat-icon  aria-hidden="false" (click)="toggleSortOrder()" fontIcon="arrow_upward"></mat-icon></button>
                       }
                       @if(isTestServer) {
                           <button mat-icon-button (click)="reloadAssets()"><mat-icon fontIcon="cached"></mat-icon></button>
                       }
                   }
                   <!-- <button mat-icon-button><mat-icon [ngClass]="{'active': renderStyle === AssetRenderStyle.tile}"  aria-hidden="false" (click)="toggleView(AssetRenderStyle.tile)" fontIcon="grid_view"></mat-icon></button>
                    <button mat-icon-button><mat-icon [ngClass]="{'active': renderStyle === AssetRenderStyle.list}"  aria-hidden="false" (click)="toggleView(AssetRenderStyle.list)" fontIcon="reorder"></mat-icon></button>-->
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 ">
            <div  class="asset-results" appFullHigh  appDrawSelector >
                @if (renderStyle === AssetRenderStyle.tile) {
                    <div class="row row-cols-auto justify-content-center ">
                        @for(asset of assets; track asset; let i = $index) {
                            @defer (on viewport) {

                                <div class="col" >
                                    <div class="asset-tile" (click)="stopPropagation($event)">
                                        <app-asset-tile [asset]="asset" [index]="i"
                                                        (loaded)="onItemLoaded($event)"
                                                        (selectAsset)="assetStatusChanged($event)"
                                                        (showDetails)="showAssetDetails($event)"

                                        ></app-asset-tile>
                                    </div>
                                </div>
                            } @placeholder  {
                                <div class="col">
                                    <div class="asset-tile">
                                        <div>loading...</div>
                                    </div>
                                </div>
                            } @error {
                                <div class="col">
                                    @if(i === 0) {
                                        <div class="asset-tile">
                                            <div class="reload">
                                                <div>
                                                    <h3>{{'newVersion' | translate}}</h3>
                                                    <p>{{'reload' |translate}}</p>
                                                </div>
                                                <div>
                                                    <button (click)="reloadApp()" mat-raised-button>{{'btn.reload' |translate}}</button>
                                                </div>

                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        }
                    </div>
                }
                @if(renderStyle === AssetRenderStyle.list) {
                    <div class="row row-cols-1 row-cols-md-2 justify-content-center ">
                        @for(asset of assets; track asset; let i = $index) {
                            @defer (on viewport) {
                                <div class="col">
                                    <div class="asset-listItem">
                                        <app-asset-list-item></app-asset-list-item>
                                    </div>
                                </div>

                            }@placeholder  {
                                <div class="col">
                                    <div class="asset-listItem">
                                        <div>loading...</div>
                                    </div>
                                </div>
                            }
                        }
                    </div>

                }
            </div>
        </div>
    </div>


</div>


